import axios from "axios";

const axiosPlugin = {
  install(app) {
    const axiosInstance = axios.create();
    app.provide("axios", axiosInstance);
  },
};
export default axiosPlugin;
